import React from "react";
import { AlertTriangle } from "lucide-react";

/**
 * Non-dismissible pedagogical / non-juridictionnel warning banner.
 * Displayed on every screen of the legal analysis module.
 */
export default function LegalWarningBanner() {
  return (
    <div
      role="alert"
      className="rounded-lg border-2 border-rose-400/60 bg-rose-50 p-4 text-rose-950 shadow-sm dark:border-rose-500/50 dark:bg-rose-950/40 dark:text-rose-100"
      data-testid="legal-warning-banner"
    >
      <div className="flex gap-3">
        <AlertTriangle className="mt-0.5 h-5 w-5 shrink-0 text-rose-600 dark:text-rose-300" />
        <div className="space-y-1 text-sm leading-relaxed">
          <div className="font-bold uppercase tracking-wide">
            ⚠️ Document pédagogique — Non juridictionnel
          </div>
          <p>
            Cette analyse est un <strong>outil d'aide à la réflexion juridique</strong>{" "}
            reposant sur la théorie vitaliste des finances publiques (ELY Mustapha).
            Elle n'a <strong>aucune valeur judiciaire</strong>, ne remplace ni un avis
            d'avocat, ni une décision de justice, ni une instruction officielle.
            Les qualifications proposées sont hypothétiques et doivent être
            validées par un professionnel du droit compétent.
          </p>
        </div>
      </div>
    </div>
  );
}
